import {lazy, Suspense} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

const Portfolio = lazy(() => import('@/modules/Portfolio'));

export default function App() {
    return (
        <Suspense fallback={null}>
            <Routes>
                <Route path="/" element={<Portfolio />} />
                <Route path="*" element={<Navigate replace to="/" />} />
            </Routes>
        </Suspense>
    );
}
